export const trainRoutes = 
    {
        path: "train",
        name: "agentTrain",
        alias: "/agent/train",
        meta: { requiresAuth: true, title: 'Dreasyfly - Train Booking' },
        component: () => import('../views/Train.vue'),
        children: [
            {
                path: "list",
                name: "NewTrainSearchListView",
                alias: "/list",
                component: () => import('../views/NewTrainSearchList.vue'),
            },
            {
                path: "process-booking",
                name: "TrainProcessBookingView",
                alias: "/process-booking",
                component: () => import('../views/TrainBookingForm.vue'),
            },
            {
                path: "report",
                name: "trainReportView",
                alias: "/report",
                component: () => import('../views/TrainReport.vue'),
            },
            {
                path: "view-train-ticket/:transactionId?",
                name: "TrainTicketView",
                alias: "/view-ticket",
                component: () => import('../views/TicketView.vue'),
            },
            {
                path: "refund-report-train",
                name: "refundTrainItem",
                alias: "/refund-report",
                component: () => import('../views/RefundTrainView.vue'),
            },
            {
                path: "get-trip-calendar",
                name: "getTripCalendar",
                alias: "/get-trip-calendar",
                component: () => import('../views/TripCalendarView.vue'),
            },
            {
                path: "manage-travellers",
                name: "manageTravellers",
                alias: "/manage-travellers",
                component: () => import('../views/ManageTravellers.vue'),
            },
        ]
    }